import { render, staticRenderFns } from "./DataNotFound.vue?vue&type=template&id=24a888cc&scoped=true"
import script from "./DataNotFound.vue?vue&type=script&lang=ts"
export * from "./DataNotFound.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a888cc",
  null
  
)

export default component.exports